<template>
  <!-- Top navigation -->
  <DetailTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType.includes('renders') && this.assetTypesReady === true"
  >
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img
            :src="
              theme.cdnUrl +
              '/types/' +
              assetType +
              '/' +
              viewType +
              '/' +
              this.assetTypes[this.order].LinkName
            "
            class="h-100"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Panoramas -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="this.assetType === '360-tour'"
  >
    <iframe
      :src="this.assetUrls[this.order]"
      title=""
      width="100%"
      height="100%"
      allow="fullscreen"
    ></iframe>
  </div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from "@/components/DetailTopNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetViewDetail",
  props: ["assetType", "viewType", "order"],
  components: {
    DetailTopNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      currentAsset: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          "/assets/plusstudio/" +
          this.assetType +
          "/" +
          this.viewType +
          "/"
      ),
      currentIndex: null,
      assetNames: null,
      assetUrls: null,
      componentName: "AssetView",
      assetTypesReady: false,
    };
  },
  created() {
    if (this.assetType === "360-tour") {
      if (this.viewType === "panorama") {
        this.assetOrder = this.theme.panoramaAsset.panoramas;
        this.assetNames = this.theme.panoramaAsset.panoramasName;
        this.assetUrls = this.theme.panoramaAsset.panoramasUrl;
      } else if (this.viewType === "retreat") {
        this.assetOrder = this.theme.retreatAsset.panoramas;
        this.assetNames = this.theme.retreatAsset.panoramasName;
        this.assetUrls = this.theme.retreatAsset.panoramasUrl;
      } else if (this.viewType === "nera") {
        this.assetOrder = this.theme.neraAsset.panoramas;
        this.assetNames = this.theme.neraAsset.panoramasName;
        this.assetUrls = this.theme.neraAsset.panoramasUrl;
      }
    }

    if (this.viewType.includes("renders")) {
      BunnyNetService.getRenders(this.folderStructure, this.assetType).then(
        (response) => {
          let j = 0;

          const menuItems = response.data.map((item) => {
            return {
              Guid: item.Guid,
              ObjectName: unslugify(item.ObjectName),
              LinkName: item.ObjectName,
              Path: item.Path,
              IsDirectory: item.IsDirectory,
              StorageZoneName: item.StorageZoneName,
              title: this.assetNames[j],
              url: this.assetUrls[j],
              id: j++,
            };
          });

          // Custom order array based on section and type
          this.assetTypes = menuItems;
          this.assetTypesReady = true;
        }
      );
    } else {
      this.assetTypesReady = true;
    }
  },
  methods: {
    // Reorder array based on config setup
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
